const organizationAction = {
    NEW_ORGANIZATION : 'new organization',

    NEW_CARRIER_ORGANIZATION : 'new carrier organization',

    NEW_AGENCY_ORGANIZATION : 'new agency organization',

    NEW_MGA_AGENCY_ORGANIZATION : 'new mga agency organization',

    NEW_MGA_CARRIER_ORGANIZATION : 'new mga carrier organization',

    IMPORT_CARRIER_LOAS : 'importCarrierLOAs',

    EXPORT_CARRIER_LOAS : 'exportCarrierLOAs',

    IMPORT_MGA_CARRIER_LOAS : 'importMgaCarrierLOAs',

    EXPORT_MGA_CARRIER_LOAS : 'exportMgaCarrierLOAs',

    BACKUP : 'backup',

    ACTIVATE : 'activate',

    DEACTIVATE : 'deactivate',

    EDIT : 'startChanges',

    SAVE_CHANGES : 'applyChanges',

    CANCEL_EDIT : 'discardChanges',

    CANCEL : 'cancel',

    EDIT_EMAIL_SIGNATURE : 'editEmailSignature'

};

angular.module('gw-um-j2js')
    .constant('organizationAction', organizationAction);